import { ColorNames } from '../../../utils/styles';

export const getStyles = (
    size: 'small' | 'medium' | 'large',
    dark: boolean = false,
    border: boolean = true
) => {
    const adaptiveColor = dark ? ColorNames.WHITE : ColorNames.BLACK;
    const divider = `1px solid ${ColorNames.GREY_DIVIDER}`;

    return {
        input: (base: any) => {
            return {
                ...base,
                color: adaptiveColor,
                fontSize: '16px',
            };
        },
        placeholder: (base: any) => {
            return {
                ...base,
                color: adaptiveColor,
                fontSize: '16px',
            };
        },
        control: (base: any) => {
            return {
                ...base,
                width: '100%',
                borderRadius: '4px',
                color: adaptiveColor,
                boxShadow: 'none',
                fontSize: '12px',
                border: border ? divider : 'none',
                backgroundColor: 'transparent',
            };
        },
        indicatorSeparator: (base: any) => {
            return { ...base, background: 'none' };
        },
        singleValue: (base: any) => {
            return {
                ...base,
                fontSize: '16px',
                color: adaptiveColor,
            };
        },
        option: (styles: any, { isFocused, isSelected }: any) => {
            return {
                ...styles,
                color: ColorNames.BLACK,
                backgroundColor:
                    isSelected || isFocused
                        ? ColorNames.BACKGROUND_GREY_DARK
                        : ColorNames.WHITE,
                alignItems: 'center',
            };
        },

        groupHeading: (base: any) => {
            return {
                ...base,
                fontWeight: 'bold',
                fontSize: '16px',
                textTransform: 'capitalize',
                color: ColorNames.BLACK,
                borderBottom: divider,
                marginBottom: '10px',
                padding: '10px',
            };
        },
        menu: (base: any) => {
            return {
                ...base,
                boxShadow: 'none',
                marginTop: '0',
            };
        },
        menuList: (base: any) => {
            return {
                ...base,
                position: 'fixed',
                minWidth: '400px', // Think of something elegant for this
                border: divider,
                borderRadius: '4px',
                padding: '0 10px',
                backgroundColor: ColorNames.WHITE,
            };
        },
        container: (base: any) => {
            return {
                ...base,
                border: 'none',
                display: 'flex',
                alignItems: 'center',
                height: size === 'large' ? '60px' : '40px',
                minWidth: '190px',
            };
        },
    };
};
